import React, { Fragment, useEffect, useState, useMemo, useCallback } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ApproveModal from "../../../Components/Common/ApproveModal";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";

import Flatpickr from "react-flatpickr";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { resetPerformancePredicateState, getPerformancePredicate as onGetPerformancePredicates, addNewPerformancePredicate as onAddNewPerformancePredicate, updatePerformancePredicate as onUpdatePerformancePredicate, deletePerformancePredicate as onDeletePerformancePredicate, getPerformancePredicateLoading } from "../../../store/performancePredicate/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import { setBranchSelect, setCompanySelect } from "../../../store/actions";

const PerformancePredicate = () => {
  const [modal, setModal] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, performancePredicates, isPerformancePredicateCreated, isPerformancePredicateSuccess, loading, error, companies, companyLoading, clients, clientLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    performancePredicates: state.PerformancePredicate.performancePredicates,
    isPerformancePredicateCreated: state.PerformancePredicate.isPerformancePredicateCreated,
    isPerformancePredicateSuccess: state.PerformancePredicate.isPerformancePredicateSuccess,
    loading: state.PerformancePredicate.loading,
    error: state.PerformancePredicate.error,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
  }));

  const [performancePredicateList, setPerformancePredicateList] = useState([]);
  const [performancePredicate, setPerformancePredicate] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [approveModal, setApproveModal] = useState(false);

  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [companyName, setCompanyName] = useState({});
  const [clientName, setClientName] = useState({});

  const [positionMessage, setPositionMessage] = useState("");
  const [defaultCompanyId, setDefaultCompanyId] = useState(null);

  const statusActiveData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "INACTIVE", value: "3" },
      ],
    },
  ];
  const onClickDelete = (performancePredicate) => {
    setPerformancePredicate(performancePredicate);
    setDeleteModal(true);
  };

  const handleDeletePerformancePredicate = () => {
    if (performancePredicate) {
      dispatch(onDeletePerformancePredicate(performancePredicate));
      setDeleteModal(false);
    }
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  // useEffect(() => {
  //   setPerformancePredicateList(performancePredicates);
  // }, [performancePredicates]);

  useEffect(() => {
    if (!isEmpty(performancePredicates)) {
      let filteredPerformancePredicates = performancePredicates;
      if (activeTypeTab !== "all") {
        filteredPerformancePredicates = performancePredicates.filter((performancePredicate) => performancePredicate.kpipp_status.name === activeTypeTab);
      }
      setPerformancePredicateList(filteredPerformancePredicates);
    }
  }, [performancePredicates]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredPerformancePredicates = performancePredicates;
      if (type !== "all") {
        filteredPerformancePredicates = performancePredicates.filter((performancePredicate) => performancePredicate.kpipp_status.name === type);
      }
      setPerformancePredicateList(filteredPerformancePredicates);
    }
  };

  useEffect(() => {
    if (companySelected) {
      setPositionMessage(`${userData?.user?.user_department && userData?.user?.user_department?.name}, ${userData?.user?.user_position && userData?.user?.user_position?.name}`);
      dispatch(resetPerformancePredicateState());
      dispatch(onGetPerformancePredicates({ companyId: companySelected?.value ?? "" }));
    }
  }, [companySelected]);

  // useEffect(() => {
  //   setPerformancePredicateList(performancePredicates);
  // }, [performancePredicates]);

  // useEffect(() => {
  //   if (!isEmpty(performancePredicates)) setPerformancePredicateList(performancePredicates);
  // }, [performancePredicates]);

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setPerformancePredicate(null);
    } else {
      setModal(true);
    }
  }, [modal]);

  const handlePerformancePredicateClick = useCallback(
    (arg) => {
      const data = arg;

      setPerformancePredicate({
        id: data.id,
        description: data.description,
        amount_to: data.amount_to,
        amount_from: data.amount_from,
        name: data.name,
        company: {
          label: data.kpipp_company.name,
          value: data.kpipp_company.id,
        },
        client: {
          label: data.kpipp_client.name,
          value: data.kpipp_client.id,
        },
      });

      setIsEdit(true);
      toggle();
    },
    [toggle]
  );

  const checkedAll = () => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".dataCheckbox");

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
  };

  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeletePerformancePredicate(element.value));
    });
    checkall.checked = false;
  };

  const onClickApprove = (employee) => {
    setPerformancePredicate(employee);
    setApproveModal(true);
  };

  const handleApproveEmployee = () => {
    if (performancePredicate) {
      performancePredicate.setApprove = true;
      dispatch(onUpdatePerformancePredicate(performancePredicate));
      dispatch(resetPerformancePredicateState());
      dispatch(onGetPerformancePredicates());
      setApproveModal(false);
    }
  };

  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" onClick={() => checkedAll()} />,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <input type="checkbox" className="dataCheckbox form-check-input me-2" value={data.id} />
              <ButtonGroup className="me-1">
                <UncontrolledButtonDropdown>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("updatePerformancePredicate") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      handlePerformancePredicateClick(data);
                    }}
                  >
                    <i className="ri-edit-2-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("deletePerformancePredicate") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      onClickDelete(data);
                    }}
                  >
                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                  </Button>
                  {data.statusId === 1 && (
                    <button
                      className={userType === "admin" || userType === "client" || userType === "company" ? "btn-label btn btn-sm btn-soft-success fs-12 me-1" : userRole && userRole.split(",").indexOf("approvePerformancePredicate") !== -1 ? "btn-label btn btn-sm btn-soft-success fs-12 me-1" : "btn-label btn btn-sm btn-soft-success fs-12 me-1 d-none"}
                      onClick={() => {
                        data.actionTitle = `Anda akan menyetujui tarif gaji untuk ${data.name}`;
                        onClickApprove(data);
                      }}
                    >
                      <i className="ri-checkbox-circle-line fs-15 label-icon align-middle me-1"></i>APPROVE
                    </button>
                  )}
                </UncontrolledButtonDropdown>
              </ButtonGroup>
            </div>
          );
        },
      },
      {
        Header: "Nama",
        accessor: "name",
        filterable: true,
      },
      {
        Header: "Value From",
        accessor: "amount_from",
        filterable: true,
      },
      {
        Header: "Value To",
        accessor: "amount_to",
        filterable: true,
      },
      {
        Header: "Keterangan",
        accessor: "description",
        filterable: true,
      },
      {
        Header: "Status",
        accessor: "kpipp_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.value) {
            case "DRAFT":
              return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
            case "ACTIVE":
              return <span className="badge text-uppercase badge-soft-info">{cell.value}</span>;
            case "INACTIVE":
              return <span className="badge text-uppercase badge-soft-danger">{cell.value}</span>;
            default:
              return <span className="badge text-uppercase badge-soft-warning">{cell.value}</span>;
          }
        },
      },
    ],
    [handlePerformancePredicateClick, userType, userRole]
  );

  const defaultdate = () => {
    return moment(new Date()).format("YYYY/MM/DD HH:mm:ss").toString();
  };

  const [filterDate, setFilterDate] = useState(null);

  const handleValidDate = (date) => {
    return moment(new Date(date), "YYYY/MM/DD").format("MMM D, YYYY");
  };

  const handleValidTime = (time) => {
    return moment(new Date(time), "YYYY/MM/DD").format("HH:mm");
  };

  //TABLE
  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: performancePredicateList,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 10,
        selectedRowIds: 0,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 600);

  function handleFilter() {
    let amount_to = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr[1]) {
      amount_to = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }

    var amount_from = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      amount_to: amount_to,
      endat: endat,
      amount_from: amount_from,
      companyId: companySelected?.value ?? "",
    };
    dispatch(onGetPerformancePredicates(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setPerformancePredicateList([]);
    setStatusActive([]);
    setSearchValue("");
    setGlobalFilter(undefined);
    dispatch(resetPerformancePredicateState());
    dispatch(onGetPerformancePredicates({ companyId: companySelected?.value ?? "" }));
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      description: (performancePredicate && performancePredicate.description) ?? "",
      amount_from: (performancePredicate && performancePredicate.amount_from) || 0,
      amount_to: (performancePredicate && performancePredicate.amount_to) | 0,
      name: (performancePredicate && performancePredicate.name) ?? "",
      client: (performancePredicate && performancePredicate.client) || clientSelected,
      company: (performancePredicate && performancePredicate.company) || companySelected,
    },
    validationSchema: Yup.object({
      amount_from: Yup.string().required("Please Pick Value From"),
      amount_to: Yup.string().required("Please Pick Value From Date"),
      name: Yup.string().required("Please Enter Predicate Name"),
      company: Yup.object().required("Please Enter company").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getPerformancePredicateLoading());
      if (isEdit) {
        const updatePerformancePredicate = {
          id: performancePredicate ? performancePredicate.id : 0,
          statusId: 1,
          description: values.description,
          amount_from: values.amount_from,
          amount_to: values.amount_to,
          name: values.name,
          companyId: values.company.value,
          clientId: values.client.value,
        };
        dispatch(onUpdatePerformancePredicate(updatePerformancePredicate));
        validation.resetForm();
      } else {
        const newPerformancePredicate = {
          statusId: 1,
          description: values.description,
          amount_from: values.amount_from,
          amount_to: values.amount_to,
          name: values.name,
          companyId: values.company.value,
          clientId: values.client.value,
        };
        dispatch(onAddNewPerformancePredicate(newPerformancePredicate));
        validation.resetForm();
      }
      toggle();
    },
  });

  document.title = "Predikat | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={performancePredicateList} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeletePerformancePredicate} onCloseClick={() => setDeleteModal(false)} />
      <ApproveModal data={performancePredicate ? performancePredicate.name : ""} show={approveModal} onApproveClick={handleApproveEmployee} onCloseClick={() => setApproveModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Guideline" pageTitle="Predikat" loading={loading}>
          <div className="flex-shrink-0">
            <button
              type="button"
              className={userType === "admin" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createPerformancePredicate") !== -1 ? "btn btn-primary add-btn me-2" : "btn btn-primary add-btn me-2 d-none"}
              id="create-btn"
              onClick={() => {
                setPerformancePredicate("");
                setIsEdit(false);
                toggle();
              }}
            >
              <i className="ri-star-line me-1 align-bottom fs-14"></i>Tambah
            </button>
            <button type="button" className="btn btn-success" onClick={() => setIsExportCSV(true)}>
              <i className="ri-file-download-line me-1 align-bottom fs-14"></i>Export
            </button>
            {/* <button className={userType === "admin" ? "btn btn-soft-danger" : userRole && userRole.split(",").indexOf("deletePerformancePredicate") !== -1 ? "btn btn-soft-danger" : "btn btn-soft-danger d-none"} onClick={() => setDeleteModalMulti(true)}>
              <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i>Hapus
            </button> */}
          </div>
        </BreadCrumb>
        <Row>
          <Col lg={12}>
            <Card id="performancePredicateList">
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"
                      >
                        <i className="ri-star-line me-1 align-bottom fs-14"></i>SEMUA PREDIKAT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i>DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "ACTIVATED");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i>ACTIVE
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "DEACTIVATED");
                        }}
                        href="#"
                      >
                        <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i>INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={2} className="col-xxl-1">
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={6}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={6} className="col-xxl-3">
                            <div className="search-box mb-2">
                              <Flatpickr
                                className="form-control"
                                id="datepicker-publish-input"
                                placeholder="Pilih Tanggal"
                                value={filterDate}
                                options={{
                                  mode: "range",
                                  dateFormat: "Y/m/d",
                                }}
                                onChange={(selectedDates, dateStr) => {
                                  setFilterDate(dateStr);
                                }}
                              />
                              <i className="bx bx-calendar-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={2}>
                            <div className="hstack gap-2">
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line align-bottom fs-16"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleResetFilter();
                                }}
                              >
                                <i className="mdi mdi-restore align-bottom fs-18"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th {...column.getSortByToggleProps()} className={"" + generateFilterable(column)} key={index}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={previousPage} disabled={!canPreviousPage}>
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={nextPage} disabled={!canNextPage}>
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Ubah Predikat" : "Tambah Predikat"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="mb-3 col-lg-12">
                          <Label htmlFor="client-field" className="form-label">
                            Grup Usaha&nbsp;{" "}
                            {clientLoading && (
                              <Spinner color="primary" size="sm">
                                Loading...
                              </Spinner>
                            )}
                          </Label>
                          <Select
                            name="client"
                            value={validation.values.client}
                            isDisabled={userType === "admin" || userType === "client" ? false : true}
                            placeholder="Pilih Grup Usaha"
                            onChange={(e) => {
                              validation.setFieldValue("client", e);
                            }}
                            options={clientList}
                          ></Select>
                        </div>

                        <div className="mb-3 col-lg-12">
                          <Label htmlFor="company-field" className="form-label">
                            Perusahaan&nbsp;{" "}
                            {companyLoading && (
                              <Spinner color="primary" size="sm">
                                Loading...
                              </Spinner>
                            )}
                          </Label>
                          <Select
                            name="company"
                            value={validation.values.company}
                            placeholder="Pilih Perusahaan"
                            isDisabled={userType === "admin" || userType === "client" ? false : true}
                            onChange={(e) => {
                              dispatch(setBranchSelect(null));
                              dispatch(setCompanySelect(e));
                              validation.setFieldValue("company", e);
                            }}
                            options={companyList}
                          ></Select>
                        </div>
                        <div className="mb-3 col-lg-12">
                          <Label htmlFor="name-field" className="form-label">
                            Nama
                          </Label>
                          <Input name="name" id="name-field" className="form-control" placeholder="Enter Predicate Name" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name} invalid={validation.touched.name && validation.errors.name ? true : false} />
                          {validation.touched.name && validation.errors.name ? <FormFeedback type="invalid">{validation.errors.name}</FormFeedback> : null}
                        </div>
                        <div className="mb-3 col-lg-6">
                          <Label htmlFor="amount_from-field" className="form-label">
                            Value From
                          </Label>
                          <Input name="amount_from" id="amount_from-field" className="form-control" placeholder="Enter Value From" type="number" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.amount_from} invalid={validation.touched.amount_from && validation.errors.amount_from ? true : false} />
                          {validation.touched.amount_from && validation.errors.amount_from ? <FormFeedback type="invalid">{validation.errors.amount_from}</FormFeedback> : null}
                        </div>
                        <div className="mb-3 col-lg-6">
                          <Label htmlFor="amount_to-field" className="form-label">
                            Value To
                          </Label>
                          <Input name="amount_to" id="amount_to-field" className="form-control" placeholder="Enter Value To" type="number" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.amount_to} invalid={validation.touched.amount_to && validation.errors.amount_to ? true : false} />
                          {validation.touched.amount_to && validation.errors.amount_to ? <FormFeedback type="invalid">{validation.errors.amount_to}</FormFeedback> : null}
                        </div>
                        <div className="mb-3 col-lg-12">
                          <Label htmlFor="description-field" className="form-label">
                            Keterangan
                          </Label>
                          <Input name="description" id="description-field" rows="4" className="form-control" placeholder="Isi Keterangan" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.description} />
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                          }}
                        >
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{"Simpan"}</span>
                            {loading ? (
                              <Spinner size="sm" className="flex-shrink-0">
                                Loading...
                              </Spinner>
                            ) : (
                              ""
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PerformancePredicate;
